// Angular
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
// RxJS
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../../../core/reducers';
// CRUD
// Services and Models
import { Client } from '../../../../../../core/lists';
import { currentUser } from 'src/app/core/auth';
import { NavigationService } from '../../../../../../core/services/navigation.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-application-qrvey-edit',
  templateUrl: './application-qrvey-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationQrveyEditComponent implements OnInit, OnDestroy {
  // Public properties
  client: Client;
  clientId$: Observable<number>;
  companyId: number;
  oldClient: Client;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  clientForm: FormGroup;
  hasFormErrors = false;
  isViewMode: boolean;
  clicked: boolean;
  isViewMode$: Observable<boolean>;
  // sticky portlet header margin
  private headerMargin: number;
  // Subscriptions
  private subscriptions: Subscription[] = [];
  urbanizationValue;
  Address1Value;
  Address2Value;
  cityValue;
  zipValue;
  params: any;
  dirstNameLabel = 'Name';
  @Input() entity_id;
  selectedTab = 0;

  /**
   * Component constructor
   *
   * @param store: Store<AppState>
   * @param activatedRoute: ActivatedRoute
   * @param router: Router
   * @param clientFB: FormBuilder
   * @param translate: TranslateService
   * @param cdr: ChangeDetectorRef
   */
  constructor(
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private navigationService: NavigationService,
  ) {}

  ngOnInit() {
    // this line due to make the navigation service return to drug groups list if there is no ->
    // navigation stack saved before in special cases
    this.navigationService.setDefaultRoot('/lists/drug-groups');
    this.activatedRoute.queryParams.subscribe((params) => {
      this.params = params;
    });
    const userSub = this.store.pipe(select(currentUser)).subscribe((res) => {
      this.companyId = res.companyID;
    });
    this.subscriptions.push(userSub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  goBack() {
    if (this.entity_id) return;
    this.loadingSubject.next(false);
    this.navigationService.goBack();
  }
}
